import * as React from "react";
import type { SVGProps } from "react";
const SvgTaskIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6 1.5a1 1 0 0 0-2 0V21H2.5a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2H6v-6h12.43a2 2 0 0 0 1.812-2.846L18.77 9l1.472-3.154A2 2 0 0 0 18.43 3H6V1.5ZM18.43 13H6V5h12.43l-1.472 3.154a2 2 0 0 0 0 1.692L18.43 13ZM10.5 8a1 1 0 0 0 0 2h3a1 1 0 1 0 0-2h-3Z"
    />
  </svg>
);
export default SvgTaskIcon;
